const CryptoJS = require('crypto-js')
const ID_ZENDESK = 'js-zendesk'
const CLASS_NAME_LOGOUT = 'js-logout'

const ZENDESK_COOKIE_KEYS = ['email', 'firstname', 'lastname', 'phone']

document.addEventListener('DOMContentLoaded', () => {
  const elementZendesk = document.getElementById(ID_ZENDESK)
  if (elementZendesk) {
    const zendeskSecretKey = elementZendesk.dataset.zendeskSecretKey
    const date = new Date()
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000)
    const expires = date.toUTCString()

    ZENDESK_COOKIE_KEYS.forEach((key) => {
      const value = elementZendesk.dataset[key]
      const valueEncrypted = CryptoJS.AES.encrypt(
        value,
        zendeskSecretKey
      ).toString()
      document.cookie = `shopify_${key}=${valueEncrypted};expires=${expires};domain=.francfranc.com`
    })
  }

  const elementsLogout = document.getElementsByClassName(CLASS_NAME_LOGOUT)
  if (elementsLogout.length) {
    Array.from(elementsLogout).forEach((element) => {
      element.addEventListener('click', () => {
        ZENDESK_COOKIE_KEYS.forEach((key) => {
          document.cookie = `shopify_${key}=;domain=.francfranc.com;expires=Thu, 01 Jan 1970 00:00:01 GMT;`
        })
      })
    })
  }

  if (window.location.href.includes('/account?via=zendesk')) {
    window.location.href =
      'https://help.francfranc.com/hc/ja/requests/new' +
      localStorage.getItem('zendesk_params')
  }
})
